<template>
  <div class="main">
    <!-- <div class="head"> -->
      <!-- <div class="div-tabs">
        <span :class="tab===1?'is-tabs':''" @click="clickTabs(1)">搜索关注</span>
        <span :class="tab===2?'is-tabs':''" @click="clickTabs(2)">推荐关注</span>
      </div> -->
      <!-- <el-radio-group v-model="tab" size="medium" @change="tabChange">
        <el-radio-button :label="1">搜索收藏</el-radio-button>
        <el-radio-button :label="2">推荐收藏</el-radio-button>
      </el-radio-group> -->
    <!-- </div> -->
    <company-card-list :companyType="9" ref="cardlist" v-loading.lock="waiting" :key="tab" :batchStarShow="false" :batchActions="batchActions" :list='cardsList'  @handle-page-num="handlePageNum" @handle-page="handlePage">
      <div class="searchBar">
        <span class="font-15-md">{{listTitle.before}}<span class="blueColor" style="color: #5088FF;"> {{listTitle.number}} </span>{{listTitle.after}}</span>
      </div>
    </company-card-list>
    <robot />
    <right-float ref="rightFloat" :globalRfType="true"></right-float>
  </div>
</template>

<script>
import Pagination from '@/components/pagination/'
import { areaCode } from '@/base/areaCode.js'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { getStarCompany, star, getContactInfo } from '../api/index.js'
import { unlockList } from '../api/newClueApi'
import CompanyCard from '../components/companyCard'
import CompanyCardList from '../components/companyCardList'
import Robot from '../components/robot'
import RightFloat from '@/components/rightFloatBtn'
export default {
  name: 'MyAttention',
  provide() {
    return {
      unlockSourceType: 9
    }
  },
  components: {
    Pagination,
    CompanyCard,
    CompanyCardList,
    Robot,
    RightFloat
  },
  data () {
    return {
      input: '',
      value: '',
      value1: '',
      options: [],
      tab: 1,
      num: 2234,
      areaCode: areaCode,
      cardsList: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        tab: 1,
        tableData: []
      },
      waiting: false,
      listTitle: {
        before: '',
        after: '',
        number: ''
      }
    }
  },
  computed: {
    ...mapState({
      surplus: state => state.user.surplus
    }),
    batchActions () {
      if (this.tab == 3) {
        return [false, false, false]
      }
      return this.surplus < 1 ? [false, false, false] : [true, false, false]
    }
  },
  mounted () {
    this.getStarCompany()
  },
  methods: {
    clickTabs (val) {
      this.tab = val
      this.cardsList.pageNum = 1
      if (val === 3) {
        this.unlockList()
      } else {
        this.getStarCompany()
      }
    },
    handlePage (val) {
      if (this.cardsList.pageNum !== val) {
        this.cardsList.pageNum = val
        if (this.tab === 3) {
          this.unlockList()
        } else {
          this.getStarCompany()
        }
      }
    },
    handlePageNum(val){
          this.cardsList.pageNum = 1
          this.cardsList.pageSize = val
          if (this.tab === 3) {
            this.unlockList()
          } else {
            this.getStarCompany()
          }
    },
    getBase (val) {
      var base = '--'
      if (val) {
        for (var i = 0; i < this.areaCode.length; i++) {
          if (val === this.areaCode[i].base) {
            base = this.areaCode[i].name
            break
          }
        }
      }
      return base
    },
    clickStar (row, val, sign) {
      var data = {
        name: row.name.replace(/<[^>]+>/g, ''),
        collect: val,
        type: sign
      }
      star(data).then(res => {
        var message = val === 0 ? '取消关注' : '关注成功'
        this.$message.success(message)
        row.star = !row.star
      })
    },
    clickEnterprise (row, sign) {
      // this.$router.push({
      //   path: '/clue/enterprise',
      //   query: {
      //     name: row.name.replace(/<[^>]+>/g, '')
      //   }
      // })
      var routeUrl = this.$router.resolve({
        path: '/clue/enterprise',
        query: {
          name: row.name.replace(/<[^>]+>/g, '')
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    tabChange (val) {
      this.cardsList.pageNum = 1
      if (val === 3) {
        this.unlockList()
      } else {
        this.getStarCompany()
      }
    },
    setTitleText (before, number, after) {
      this.listTitle.before = before
      this.listTitle.number = number
      this.listTitle.after = after
    },
    async unlockList () {
      this.waiting = true
      this.cardsList.tableData = []
      const data = {
        pageSize: this.cardsList.pageSize,
        pageNum: this.cardsList.pageNum
      }
      const res = await unlockList(data)
      this.cardsList.tableData = res.data.records.map(e => {
        return { ...e, unlock: true }
      })
      this.cardsList.total = res.data.total
      this.setTitleText('您共解锁', res.data.total, '企业商机资源')
      this.waiting = false
    },
    async getStarCompany () {
      this.waiting = true
      this.cardsList.tableData = []
      const data = {
        type: this.tab,
        pageSize: this.cardsList.pageSize,
        pageNum: this.cardsList.pageNum
      }
      const res = await getStarCompany(data)
      this.cardsList.tableData = res.data.records
      this.cardsList.tableData.forEach(e => {
        this.$set(e, 'star', true)
      })

      this.cardsList.total = res.data.total
      this.setTitleText('您共收藏', res.data.total, '商机资源')
      this.waiting = false
    }

  }
}
</script>
<style lang='scss' scoped>
.div-tabs {
  height: 48px;
  padding: 17px 0 0;
  box-sizing: border-box;
  margin: 0 24px;
  border-bottom: 1px solid #EEEEEE;
  .is-tabs {
    border-bottom: 2px solid #5088FF;
    font-weight: bold;
   color: #333333;
  }
  span {
    display: inline-block;
    // width: 120px;
    text-align: center;
    height: 100%;
    cursor: pointer;
    height: calc(100% + 1px);
    position: relative;
    top: 0px;
    color: #333333;
    font-size: 15px;
    padding: 0 15px;
    box-sizing: border-box;
  }
}
.head {
  background: #FFFFFF;
   box-shadow: 0px 1px 5px 0px rgba(38, 38, 38, 0.1);
  // padding: 25px 24px;
  padding-bottom: 16px;
}
.content {
  padding-bottom: 25px;
  background-color: #fff;
  .cardTitle {
    border-bottom: 2px solid #f0f2f5;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    > span {
      color: #d9001b;
    }
  }
}
.font-16-md{
  font-size: 16px;
  font-weight: 600;
  color: rgba(52,57,81,0.7);
}
.font-15-md{
  font-size: 15px;
  font-weight: 600;
  color: rgba(52,57,81,0.7);
}
</style>
